<router-outlet></router-outlet>
<vex-loading-spinner></vex-loading-spinner>

